<script>
  export let styles = "";
  export let fontSize = "1.25rem";
  export let disabled = false;
  export let disabledReason = ""; // We tell the user why they cannot click submit
</script>

<div class="button" class:disabled style={styles}>
  <div class="bottom" />

  <div class="top" style="font-size: {fontSize}">
    <slot />

    <div class="button-border button-border-left" />
    <div class="button-border button-border-top" />
    <div class="button-border button-border-right" />
    <div class="button-border button-border-bottom" />
  </div>
  {#if disabled && disabledReason}
    <span class="disabled-reason">{disabledReason}</span>
  {/if}
</div>

<style>
  .disabled-reason {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translateX(15px) translateY(25px) rotate(-10deg);
    background: white;
    width: 100px;
    text-align: center;
    padding: 0.25rem;
    font-weight: 200;
    border: 1px solid var(--accent-color);
    opacity: 0;
    transition: opacity 200ms ease-in-out, transform 400ms ease;
  }

  .button:hover .disabled-reason {
    opacity: 1;
    transform: translateX(25px) translateY(25px) rotate(-10deg);
  }

  .button {
    display: block;
    text-decoration: none;
    position: relative;
    cursor: pointer;
    margin: auto;
    width: max-content;
    pointer-events: all;
  }

  :global(.button button) {
    color: white;
    text-transform: uppercase;
    font-size: inherit;
    cursor: pointer;
    width: 100%;
    font-family: var(--font-serif);
    font-weight: 700;
    padding: 0.25rem 0.85rem;
  }

  :global(.button .disabled) {
    cursor: not-allowed;
    color: rgba(var(--text-color-rgb), 0.5);
    background: rgba(var(--primary-color-rgb), 0.8);
  }

  .button .bottom {
    position: absolute;
    left: 7px;
    top: 7px;
    width: 100%;
    height: 100%;
    background-color: var(--accent-color);
    display: block;
    -webkit-transition: all 0.15s ease-out;
    -moz-transition: all 0.15s ease-out;
    -o-transition: all 0.15s ease-out;
    transition: all 0.15s ease-out;
    pointer-events: none; /* Prevent jitter */
  }

  .button .top {
    min-width: 120px;
    min-height: 60px;
  }

  .button .top {
    position: relative;
    left: 0;
    top: 0;
    border: 2px solid var(--text-color);
    display: flex;
  }

  .button:hover .bottom {
    left: 0;
    top: 0;
    background-color: #f3f3f3;
  }

  :global(.button:hover button) {
    color: var(--accent-color);
  }

  .button-border {
    position: absolute;
    background-color: var(--accent-color);
    -webkit-transition: all 0.25s ease-out;
    -moz-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
  }

  .button:hover .top .button-border-left,
  .button:hover .top .button-border-right {
    height: calc(100% + 2px);
  }

  .button:hover .top .button-border-top,
  .button:hover .top .button-border-bottom {
    width: calc(100% + 2px);
  }

  .button-border-left {
    left: -2px;
    bottom: -2px;
    width: 2px;
    height: 0;
  }

  .button-border-top {
    left: -2px;
    top: -2px;
    width: 0;
    height: 2px;
  }

  .button-border-right {
    right: -2px;
    top: -2px;
    width: 2px;
    height: 0;
  }

  .button-border-bottom {
    right: -2px;
    bottom: -2px;
    width: 0;
    height: 2px;
  }
</style>
